export const DiscoIcon = () => [
  <svg
    fill="currentColor"
    height="24px"
    width="24px"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <g>
      <g>
        <path
          d="M305.169,89.716V50.772c0-4.428-3.589-8.017-8.017-8.017h-26.188V8.017c0-4.428-3.589-8.017-8.017-8.017
			s-8.017,3.588-8.017,8.017v34.739h-26.188c-4.427,0-8.017,3.588-8.017,8.017v38.944
			C123.298,109.364,49.704,195.624,49.704,298.756C49.704,416.339,145.364,512,262.948,512c30.267,0,59.951-6.441,87.156-18.619
			l0.509,2.035c0.891,3.569,4.098,6.072,7.777,6.072c3.679,0,6.885-2.503,7.777-6.072l2.93-11.718
			c11.606-6.659,22.63-14.425,32.889-23.255c3.356-2.888,3.735-7.95,0.847-11.306c-2.888-3.355-7.95-3.736-11.306-0.847
			c-5.387,4.637-11.004,8.954-16.816,12.952l3.51-14.041l42.618-14.552c3.245-1.108,5.426-4.158,5.426-7.587
			c0-3.429-2.182-6.479-5.426-7.587l-42.618-14.552l-12.054-48.215c-0.891-3.569-4.098-6.072-7.777-6.072
			c-3.679,0-6.885,2.503-7.777,6.072l-12.054,48.215l-42.618,14.552c-3.245,1.108-5.426,4.158-5.426,7.587
			c0,3.429,2.182,6.479,5.426,7.587l42.618,14.552l7.588,30.351c-19.241,8.95-39.873,14.777-61.103,17.171
			c5.623-10.129,10.552-24.753,14.858-43.997c0.966-4.322-1.752-8.608-6.073-9.574c-4.319-0.96-8.607,1.754-9.573,6.073
			c-8.901,39.786-18.608,48.741-21.307,48.741c-2.903,0-13.248-9.87-22.385-53.728c-0.546-2.623-1.074-5.31-1.586-8.05
			c7.906,0.559,15.903,0.851,23.971,0.851c4.427,0,8.017-3.588,8.017-8.017c0-4.428-3.589-8.017-8.017-8.017
			c-9.016,0-17.934-0.378-26.716-1.104c-3.151-20.793-5.426-44.123-6.731-68.935c10.96,0.37,22.135,0.561,33.447,0.561
			c11.306,0,22.473-0.191,33.427-0.56c-0.93,17.595-2.344,34.561-4.221,50.359c-0.523,4.396,2.619,8.384,7.015,8.906
			c4.389,0.528,8.383-2.619,8.907-7.015c1.972-16.595,3.442-34.437,4.389-52.929c27.632-1.408,53.55-3.996,76.364-7.642
			c-2.282,16.076-5.891,31.656-10.828,46.598c-1.389,4.204,0.894,8.738,5.098,10.127c4.2,1.391,8.737-0.893,10.127-5.098
			c5.767-17.456,9.823-35.711,12.166-54.568c1.452-0.286,2.89-0.575,4.309-0.87c20.226-4.214,35.736-9.071,46.68-14.631
			c-7.522,23.029-26.099,44.285-54.132,61.42c-3.779,2.309-4.968,7.243-2.659,11.021c2.309,3.779,7.243,4.968,11.021,2.659
			c14.915-9.117,27.455-19.375,37.455-30.485c-4.532,12.338-10.291,24.24-17.26,35.51c-2.329,3.765-1.164,8.706,2.602,11.034
			c3.765,2.327,8.706,1.163,11.035-2.603c20.771-33.588,31.75-72.319,31.75-112.006C476.192,195.624,402.598,109.364,305.169,89.716
			z M323.34,425.063l24.529-8.376c2.574-0.879,4.527-3.004,5.186-5.642l5.335-21.338l5.335,21.338
			c0.659,2.639,2.612,4.763,5.186,5.642l24.529,8.376l-24.529,8.376c-2.574,0.879-4.527,3.004-5.186,5.642l-5.335,21.338
			l-5.335-21.338c-0.66-2.639-2.612-4.763-5.186-5.642L323.34,425.063z M236.76,58.789h52.376v28.332
			c-8.584-1.056-17.322-1.61-26.188-1.61c-8.865,0-17.604,0.554-26.188,1.61V58.789z M262.948,162.472
			c-8.068,0-16.066,0.292-23.971,0.851c0.512-2.74,1.04-5.428,1.586-8.05c9.137-43.858,19.482-53.728,22.385-53.728
			s13.248,9.87,22.385,53.728c0.546,2.623,1.074,5.311,1.586,8.05C279.013,162.764,271.016,162.472,262.948,162.472z
			 M289.664,179.609c3.151,20.793,5.426,44.123,6.731,68.935c-10.96-0.37-22.135-0.561-33.447-0.561
			c-11.312,0-22.486,0.191-33.447,0.561c1.305-24.812,3.58-48.142,6.731-68.935c8.782-0.726,17.7-1.104,26.716-1.104
			C271.964,178.505,280.882,178.884,289.664,179.609z M239.793,104.744c-5.684,10.972-10.639,26.676-14.926,47.259
			c-0.867,4.159-1.689,8.47-2.472,12.906c-21.685,2.637-42.459,7.387-61.703,14.084
			C179.779,140.876,207.732,113.692,239.793,104.744z M212.736,332.203c-28.29-1.488-54.659-4.235-77.53-8.105
			c-0.698-8.299-1.06-16.757-1.06-25.341s0.362-17.042,1.06-25.34c22.871-3.87,49.239-6.619,77.53-8.106
			c-0.37,10.96-0.561,22.135-0.561,33.447C212.175,310.068,212.367,321.242,212.736,332.203z M213.415,348.288
			c1.236,24.237,3.379,47.155,6.347,67.816c-24.395-3.333-47.441-9.49-68.12-18.209c-6.692-17.548-11.664-36.811-14.562-57.246
			C159.886,344.294,185.795,346.881,213.415,348.288z M213.415,249.223c-27.621,1.408-53.529,3.994-76.334,7.638
			c2.899-20.435,7.869-39.698,14.563-57.246c20.679-8.719,43.724-14.876,68.12-18.209
			C216.795,202.069,214.651,224.986,213.415,249.223z M187.263,116.656c-9.996,9.02-19.307,19.901-27.73,32.535
			c-7.835,11.751-14.628,24.634-20.329,38.384c-9.011,4.097-17.583,8.659-25.622,13.684c-14.149,8.843-26.114,18.734-35.727,29.415
			C96.859,179.17,136.782,137.715,187.263,116.656z M122.079,214.855c2.988-1.867,6.063-3.66,9.204-5.392
			c-4.987,15.989-8.607,32.877-10.774,50.34c-1.453,0.286-2.895,0.576-4.314,0.871c-20.215,4.211-35.719,9.065-46.661,14.622
			C76.926,252.721,94.949,231.811,122.079,214.855z M65.737,298.756c0-2.89,9.795-13.156,53.155-22.263
			c-0.512,7.349-0.779,14.775-0.779,22.263s0.267,14.914,0.779,22.263C75.532,311.912,65.737,301.646,65.737,298.756z
			 M116.195,336.837c1.419,0.296,2.861,0.586,4.314,0.871c2.168,17.463,5.787,34.351,10.774,50.34
			c-3.141-1.733-6.217-3.525-9.204-5.392c-27.13-16.956-45.153-37.866-52.546-60.442C80.476,327.772,95.981,332.626,116.195,336.837
			z M77.854,366.838c9.613,10.68,21.578,20.572,35.727,29.415c8.039,5.025,16.611,9.587,25.622,13.684
			c5.701,13.75,12.494,26.633,20.329,38.384c8.423,12.634,17.734,23.515,27.73,32.535
			C136.782,459.796,96.859,418.341,77.854,366.838z M239.793,492.767c-32.061-8.948-60.014-36.133-79.101-74.249
			c19.244,6.697,40.018,11.447,61.703,14.084c0.782,4.436,1.606,8.747,2.472,12.906
			C229.156,466.092,234.109,481.796,239.793,492.767z M297.084,332.904c-11.168,0.39-22.575,0.591-34.136,0.591
			c-11.564,0-22.976-0.201-34.148-0.591c-0.39-11.172-0.591-22.583-0.591-34.148c0-11.565,0.201-22.976,0.591-34.148
			c11.172-0.39,22.584-0.591,34.148-0.591c11.564,0,22.976,0.201,34.148,0.591c0.39,11.172,0.591,22.583,0.591,34.148
			C297.687,310.241,297.482,321.664,297.084,332.904z M303.501,164.909c-0.784-4.436-1.605-8.747-2.472-12.906
			c-4.288-20.584-9.242-36.287-14.926-47.259c32.061,8.948,60.014,36.132,79.101,74.249
			C345.959,172.296,325.185,167.546,303.501,164.909z M306.132,181.407c24.395,3.333,47.441,9.49,68.12,18.209
			c6.693,17.548,11.664,36.811,14.563,57.246c-22.805-3.643-48.714-6.231-76.334-7.638
			C311.245,224.986,309.102,202.069,306.132,181.407z M390.689,324.097c-22.872,3.87-49.242,6.617-77.534,8.105
			c0.375-11.02,0.565-22.207,0.565-33.447c0-11.312-0.191-22.486-0.561-33.447c28.29,1.488,54.659,4.235,77.53,8.106
			c0.698,8.298,1.06,16.756,1.06,25.34C391.75,307.31,391.387,315.761,390.689,324.097z M386.691,187.575
			c-5.701-13.75-12.494-26.633-20.329-38.384c-8.423-12.634-17.734-23.515-27.73-32.535
			c50.481,21.059,90.404,62.513,109.408,114.018c-9.61-10.68-21.576-20.571-35.726-29.415
			C404.275,196.235,395.703,191.672,386.691,187.575z M405.386,259.802c-2.168-17.463-5.787-34.351-10.774-50.34
			c3.141,1.733,6.217,3.525,9.204,5.391c27.13,16.956,45.153,37.866,52.546,60.442c-10.942-5.557-26.448-10.411-46.661-14.622
			C408.281,260.377,406.839,260.087,405.386,259.802z M407.005,321.018c0.51-7.344,0.778-14.766,0.778-22.262
			c0-7.487-0.267-14.913-0.779-22.263c43.361,9.107,53.155,19.373,53.155,22.263C460.159,301.646,450.364,311.912,407.005,321.018z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M504.971,68.839l-42.618-14.552L450.299,6.072C449.407,2.503,446.2,0,442.522,0c-3.678,0-6.885,2.503-7.777,6.072
			l-12.054,48.215l-42.618,14.552c-3.245,1.108-5.426,4.158-5.426,7.587s2.182,6.479,5.426,7.587l42.618,14.552l12.054,48.215
			c0.891,3.569,4.098,6.072,7.777,6.072c3.679,0,6.885-2.503,7.777-6.072l12.054-48.215l42.618-14.552
			c3.245-1.108,5.426-4.158,5.426-7.587S508.215,69.947,504.971,68.839z M453.043,84.802c-2.574,0.879-4.527,3.004-5.186,5.642
			l-5.335,21.338l-5.335-21.338c-0.659-2.639-2.612-4.763-5.186-5.642l-24.529-8.376l24.529-8.376
			c2.574-0.879,4.527-3.004,5.186-5.642l5.335-21.338l5.335,21.338c0.66,2.639,2.612,4.763,5.186,5.642l24.529,8.376L453.043,84.802
			z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M131.927,103.043L89.309,88.492L77.255,40.277c-0.893-3.569-4.099-6.072-7.777-6.072c-3.678,0-6.885,2.503-7.777,6.072
			L49.647,88.492L7.029,103.043c-3.208,1.097-5.426,4.196-5.426,7.587c0,3.391,2.218,6.49,5.426,7.587l42.618,14.552l12.054,48.215
			c0.893,3.569,4.099,6.072,7.777,6.072c3.678,0,6.885-2.503,7.777-6.072l12.054-48.215l42.618-14.552
			c3.245-1.108,5.426-4.158,5.426-7.587S135.171,104.152,131.927,103.043z M79.999,119.006c-2.574,0.879-4.527,3.004-5.186,5.642
			l-5.335,21.338l-5.335-21.338c-0.66-2.639-2.612-4.763-5.186-5.642l-24.529-8.376l24.529-8.376
			c2.574-0.879,4.527-3.004,5.186-5.642l5.335-21.338l5.335,21.338c0.659,2.639,2.612,4.763,5.186,5.642l24.529,8.376
			L79.999,119.006z"
        />
      </g>
    </g>
  </svg>
];
